import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Select from "react-select";
import Footer from "../layout/footer";
import NavigationBar from "../layout/NavigationBar";
import LoadingSpinner from "./LoadingSpinner";
import axios from "axios";
import api from "../api/axiosInstance";
import fetchWithJWT from "../api/fetchWithJWT";

const Profile = () => {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [profileData, setProfileData] = useState({
        first_name: "",
        last_name: "",
        email_address: "",
        business_name: "",
        phone_number: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
        country: "India"
    });

    const [errors, setErrors] = useState({});

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
        "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
        "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
        "West Bengal", "Delhi", "Jammu and Kashmir", "Ladakh", "Puducherry"
    ];
    const statesOfIndia = [
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Bihar',
        'Chhattisgarh',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal',
    ];
    const statesCitiesMap = {
        'Andhra Pradesh': ['Adoni', 'Amaravati', 'Anantapur', 'Chandragiri', 'Chittoor', 'Dowlaiswaram', 'Eluru', 'Guntur', 'Kadapa', 'Kakinada', 'Kurnool', 'Machilipatnam', 'Nagarjunakoṇḍa', 'Rajahmundry', 'Srikakulam', 'Tirupati', 'Vijayawada', 'Visakhapatnam', 'Vizianagaram', 'Yemmiganur', 'Nellore', 'Proddatur', 'Hindupur', 'Bhimavaram', 'Madanapalle', 'Guntakal', 'Dharmavaram', 'Gudivada', 'Narasaraopet', 'Kadiri', 'Tadipatri', 'Mangalagiri', 'Chilakaluripet'],
        'Arunachal Pradesh': ['Itanagar', 'Tezpur', 'Pasighat', 'Ziro', 'Along', 'Bomdila', 'Tawang', 'Changlang', 'Namsai', 'Seppa', 'Tezu', 'Khonsa', 'Daporijo', 'Naharlagun', 'Roing', 'Anini', 'Longding', 'Koloriang', 'Basar', 'Yingkiong'],
        'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Nagaon', 'Tinsukia', 'Jorhat', 'Barpeta', 'Tezpur', 'Karimganj', 'Sibsagar', 'Diphu', 'North Lakhimpur', 'Hojai', 'Mangaldoi', 'Lumding', 'Haflong', 'Hailakandi', 'Morigaon', 'Nalbari', 'Rangia', 'Silapathar', 'Dhubri', 'Bilasipara', 'Goalpara', 'Bongaigaon', 'Kokrajhar', 'Gossaigaon', 'Abhayapuri', 'Gauripur', 'Golokganj', 'Marigaon', 'Tangla'],
        'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Darbhanga', 'Bihar Sharif', 'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Danapur', 'Saharsa', 'Sasaram', 'Hajipur', 'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha', 'Buxar', 'Kishanganj', 'Sitamarhi', 'Jehanabad', 'Aurangabad', 'Lakhisarai', 'Sheikhpura', 'Supaul', 'Madhepura', 'Gopalganj', 'Bettiah', 'Forbesganj', 'Khagaria', 'Sultanganj', 'Raxaul', 'Bhabua', 'Purnia'],
        'Chhattisgarh': ['Raipur', 'Bhilai Nagar', 'Korba', 'Bilaspur', 'Durg', 'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Mahasamund', 'Dhamtari', 'Chirmiri', 'Janjgir', 'Sakti', 'Tilda Newra', 'Mungeli', 'Manendragarh', 'Naila Janjgir', 'Bhatapara', 'Dalli-Rajhara', 'Nagarnar', 'Kanker', 'Tilda Neora', 'Dongargarh', 'Akaltara', 'Champa', 'Jashpur Nagar', 'Baloda Bazar', 'Kondagaon', 'Baikunthpur', 'Takhatpur'],
        'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem', 'Sanquelim', 'Cuncolim', 'Quepem', 'Canacona', 'Valpoi', 'Pernem', 'Aldona', 'Arambol', 'Anjuna', 'Calangute', 'Candolim', 'Colva', 'Benaulim', 'Cavelossim', 'Majorda', 'Agonda', 'Palolem', 'Patnem', 'Chaudi', 'Cortalim', 'Nuvem', 'Raia', 'Loutolim', 'Chinchinim', 'Assolna'],
        'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand', 'Navsari', 'Morbi', 'Nadiad', 'Surendranagar', 'Bharuch', 'Mehsana', 'Bhuj', 'Porbandar', 'Palanpur', 'Valsad', 'Vapi', 'Gondal', 'Veraval', 'Godhra', 'Patan', 'Kalol', 'Dahod', 'Botad', 'Amreli', 'Deesa', 'Jetpur', 'Kadi', 'Bardoli', 'Ankleshwar', 'Modasa', 'Himmatnagar', 'Idar', 'Vyara', 'Keshod', 'Mangrol', 'Dhoraji', 'Upleta', 'Una', 'Sidhpur', 'Wankaner'],
        'Haryana': ['Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 'Karnal', 'Sonipat', 'Panchkula', 'Bhiwani', 'Sirsa', 'Bahadurgarh', 'Jind', 'Thanesar', 'Kaithal', 'Palwal', 'Rewari', 'Hansi', 'Narnaul', 'Fatehabad', 'Gohana', 'Tohana', 'Narwana', 'Mandi Dabwali', 'Charkhi Dadri', 'Shahbad', 'Pehowa', 'Samalkha', 'Pinjore', 'Ladwa', 'Sohna', 'Safidon', 'Taraori', 'Mahendragarh', 'Ratia', 'Rania', 'Sarsod'],
        'Himachal Pradesh': ['Shimla', 'Mandi', 'Solan', 'Nahan', 'Bilaspur', 'Kullu', 'Hamirpur', 'Una', 'Kangra', 'Dharamshala', 'Palampur', 'Baddi', 'Nalagarh', 'Chamba', 'Sundernagar', 'Paonta Sahib', 'Jogindernagar', 'Rampur Bushahr', 'Jawalamukhi', 'Nurpur', 'Anni', 'Theog', 'Kasauli', 'Gagret', 'Chuari Khas', 'Dalhousie', 'Manali', 'Keylong', 'Rekong Peo', 'Narkanda', 'Sarahan', 'Tattapani', 'Rohru', 'Kotkhai'],
        'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro Steel City', 'Deoghar', 'Phusro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Medininagar', 'Chirkunda', 'Pakaur', 'Chaibasa', 'Dumka', 'Sahibganj', 'Jhumri Telaiya', 'Chatra', 'Gumla', 'Simdega', 'Koderma', 'Khunti', 'Bundu', 'Tamar', 'Lohardaga', 'Tenu Dam-cum-Kathhara', 'Ramnagar', 'Nala', 'Rajmahal', 'Mihijam', 'Patratu', 'Barhi', 'Hunterganj', 'Ghatsila', 'Golmuri', 'Jugsalai'],
        'Karnataka': ['Bangalore', 'Hubli-Dharwad', 'Mysore', 'Gulbarga', 'Mangalore', 'Belgaum', 'Davanagere', 'Bellary', 'Bijapur', 'Shimoga', 'Tumkur', 'Raichur', 'Bidar', 'Hospet', 'Hassan', 'Gadag-Betageri', 'Udupi', 'Robertsonpet', 'Bhadravati', 'Chitradurga', 'Kolar', 'Mandya', 'Chikmagalur', 'Gangavati', 'Bagalkot', 'Ranibennur', 'Ranebennuru', 'Karnataka', 'Koppal', 'Mundargi', 'Sirsi', 'Sindhnur', 'Tiptur', 'Arsikere', 'Nanjangud', 'Sagara', 'Sira', 'Puttur', 'Athni', 'Mulbagal', 'Surapura', 'Siruguppa', 'Mudhol', 'Sidlaghatta', 'Shahabad', 'Saundatti-Yellamma', 'Wadi', 'Manvi', 'Nelamangala', 'Lakshmeshwar', 'Jevargi', 'Shiggaon', 'Muddebihal', 'Magadi', 'Rabkavi Banhatti', 'Savanur', 'Ramdurg', 'Shahpur', 'Malavalli', 'Sandur', 'Gurmatkal', 'Ron', 'Chincholi', 'Kollegal', 'Haliyal', 'Dandeli', 'Karwar', 'Brahmavar', 'Karkala'],
        'Kerala': ['Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Kollam', 'Thrissur', 'Palakkad', 'Alappuzha', 'Malappuram', 'Kannur', 'Kasaragod', 'Kottayam', 'Pathanamthitta', 'Idukki', 'Wayanad', 'Ernakulam', 'Thodupuzha', 'Kayamkulam', 'Neyyattinkara', 'Tanur', 'Chalakudy', 'Changanassery', 'Punalur', 'Nilambur', 'Cherthala', 'Perinthalmanna', 'Mattannur', 'Payyannur', 'Kanhangad', 'Koyilandy', 'Parappanangadi', 'Kalamassery', 'Ottappalam', 'Tirur', 'Kodungallur', 'Sreekandapuram', 'Rathinagiri', 'Mananthavady', 'Wadakkanchery', 'Attingal', 'Varkala', 'Paravur', 'Pathanapuram', 'Peringathur', 'Bagalur', 'Milad un Nabi', 'Ponnani', 'Pandalam', 'Manjeri', 'Mavelikkara', 'Perumbavoor', 'Vaikom', 'Palai', 'Panniyannur', 'Guruvayoor', 'Puthuppally'],
        'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa', 'Murwara', 'Singrauli', 'Burhanpur', 'Khandwa', 'Bhind', 'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Chhatarpur', 'Damoh', 'Mandsaur', 'Khargone', 'Neemuch', 'Pithampur', 'Narmadapuram', 'Itarsi', 'Sehore', 'Betul', 'Seoni', 'Datia', 'Nagda', 'Dindori', 'Ashok Nagar'],
        'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Allahabad', 'Solapur', 'Amravati', 'Kolhapur', 'Ulhasnagar', 'Sangli-Miraj & Kupwad', 'Malegaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar', 'Chandrapur', 'Parbhani', 'Jalgaon', 'Bhusawal', 'Nanded-Waghala', 'Satara', 'Beed', 'Yavatmal', 'Kamptee', 'Gondia', 'Barshi', 'Achalpur', 'Osmanabad', 'Nandurbar', 'Wardha', 'Udgir', 'Hinganghat'],
        'Manipur': ['Imphal', 'Thoubal', 'Lilong', 'Mayang Imphal', 'Lamlong', 'Bishnupur', 'Churachandpur', 'Kakching', 'Senapati', 'Tamenglong', 'Jiribam', 'Chandel', 'Ukhrul', 'Noney', 'Tengnoupal', 'Kamjong', 'Kangpokpi', 'Pherzawl'],
        'Meghalaya': ['Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara', 'Williamnagar', 'Nongpoh', 'Mairang', 'Mawkyrwat', 'Ampati', 'Resubelpara', 'Khliehriat', 'Amlarem', 'Tikrikilla', 'Cherrapunji', 'Dawki', 'Bholaganj', 'Rongjeng', 'Mendipathar', 'Dadengiri', 'Dalu', 'Mahendraganj', 'Chokpot'],
        'Mizoram': ['Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Kolasib', 'Serchhip', 'Mamit', 'Lawngtlai', 'Saitual', 'Khawzawl', 'Hnahthial'],
        'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Phek', 'Kiphire', 'Longleng', 'Peren', 'Mon'],
        'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri', 'Balasore', 'Bhadrak', 'Baripada', 'Jharsuguda', 'Jeypore', 'Barbil', 'Khordha', 'Sunabeda', 'Rayagada', 'Byasanagar', 'Jatani', 'Kendujhar', 'Jagatsinghpur', 'Koraput', 'Kendrapara', 'Paradip', 'Bhawanipatna', 'Dhenkanal', 'Titlagarh', 'Nabarangpur', 'Malkangiri', 'Talcher', 'Bolangir', 'Nuapada', 'Kantabanji', 'Phulbani', 'Nimapara', 'Nayagarh', 'Soro', 'Hinjilikatu', 'Gunupur', 'Rajgangpur', 'Sundargarh', 'Tarbha', 'Belpahar', 'Brajarajnagar', 'Paradeep', 'Jajpur', 'Anandapur', 'Karanjia', 'Basta', 'Udala', 'Basudevpur', 'Chandbali', 'Erasama'],
        'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Hoshiarpur', 'Batala', 'Pathankot', 'Moga', 'Abohar', 'Malerkotla', 'Khanna', 'Mohali', 'Barnala', 'Firozpur', 'Phagwara', 'Kapurthala', 'Zirakpur', 'Kotkapura', 'Faridkot', 'Muktsar', 'Rajpura', 'Sangrur', 'Fazilka', 'Gurdaspur', 'Kharar', 'Gobindgarh', 'Mansa', 'Malout', 'Nabha', 'Tarn Taran', 'Jagraon', 'Sunam', 'Dhuri', 'Sirhind Fatehgarh Sahib', 'Rupnagar', 'Jalandhar Cantt', 'Samana', 'Sultanpur Lodhi', 'Longowal', 'Dhilwan', 'Ghanaur'],
        'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bharatpur', 'Sikar', 'Bhilwara', 'Sri Ganganagar', 'Pali', 'Kishangarh', 'Beawar', 'Jhunjhunu', 'Gangapur City', 'Churu', 'Dhaulpur', 'Hanumangarh', 'Tonk', 'Sawai Madhopur', 'Kuchaman City', 'Makrana', 'Sujangarh', 'Lachhmangarh', 'Rajsamand', 'Nasirabad', 'Nohar', 'Phalodi', 'Nathdwara', 'Taranagar', 'Bundi', 'Lalsot', 'Sardarshahar', 'Ladnu', 'Deshnok', 'Didwana', 'Karauli', 'Suratgarh', 'Kankroli', 'Nimbahera', 'Jalore', 'Nokha', 'Jhalawar', 'Barmer', 'Osian', 'Kishanganj', 'Neem-Ka-Thana', 'Losal', 'Nadbai', 'Shrimadhopura', 'Todaraisingh', 'Reengus', 'Rajakhera', 'Shahpura', 'Raisinghnagar', 'Merta City', 'Kapasan', 'Degana', 'Madanganj-Kishangarh', 'Nagaur', 'Rajgarh (Churu)', 'Ratangarh', 'Sadulshahar', 'Sadri', 'Sanchore', 'Sheoganj', 'Sirohi', 'Sojat', 'Sumel', 'Takhatgarh'],
        'Sikkim': ['Gangtok', 'Namchi', 'Geyzing', 'Mangan', 'Rangpo', 'Singtam', 'Jorethang', 'Nayabazar', 'Gyalshing', 'Yuksom', 'Ravangla', 'Melli', 'Pakyong', 'Rhenock', 'Samdong', 'Soreng', 'Tadong', 'Temi', 'Chungthang', 'Lachen', 'Lachung', 'Yumthang'],
        'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Tiruppur', 'Ranipet', 'Nagercoil', 'Thanjavur', 'Vellore', 'Kancheepuram', 'Erode', 'Thoothukudi', 'Dindigul', 'Pollachi', 'Rajapalayam', 'Sivakasi', 'Pudukkottai', 'Neyveli (TS)', 'Nagapattinam', 'Viluppuram', 'Tiruchengode', 'Vaniyambadi', 'Theni Allinagaram', 'Udhagamandalam', 'Aruppukkottai', 'Paramakudi', 'Arakkonam', 'Virudhachalam', 'Srivilliputhur', 'Tindivanam', 'Virudhunagar', 'Karur', 'Valparai', 'Sankarankovil', 'Tenkasi', 'Palani', 'Pattukkottai', 'Tirupathur', 'Ramanathapuram', 'Udumalaipettai', 'Gobichettipalayam', 'Thiruvarur', 'Thiruvallur', 'Panruti', 'Namakkal', 'Thirumangalam', 'Vikramasingapuram', 'Attur', 'Sankaridrug', 'Cumbum', 'Thuraiyur', 'Udankudi', 'Manjeri', 'Usilampatti', 'Sulthanbathery', 'Shajapur', 'Vadakkuvalliyur', 'Tirukkoyilur', 'Oddanchatram', 'Palladam', 'Kodaikanal', 'Velur', 'Sholavandan', 'Kumbakonam', 'Hosur', 'Ponneri', 'Vedaranyam', 'Chidambaram', 'Cuddalore', 'Mayiladuthurai', 'Yercaud', 'Kumily', 'Annur', 'Sholinganallur', 'Ambattur', 'Chromepet'],
        'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Khammam', 'Karimnagar', 'Ramagundam', 'Mahabubnagar', 'Nalgonda', 'Adilabad', 'Suryapet', 'Siddipet', 'Miryalaguda', 'Jagtial', 'Mancherial', 'Gadwal', 'Kothagudem', 'Bodhan', 'Sangareddy', 'Metpally', 'Zahirabad', 'MedChal', 'Jangaon', 'Mandamarri', 'Medak', 'Farooqnagar', 'Tandur', 'Kodad', 'Armoor', 'Wanaparthy', 'Palwancha', 'Banswada', 'Kalwakurthy', 'Nagarkurnool', 'Pargi', 'Vikarabad', 'Jainpur', 'Bhainsa', 'Nirmal', 'Kamareddy', 'Bhongir', 'Yellandu'],

    };

    const stateOptions = statesOfIndia.map(state => ({
        value: state,
        label: state
    }));
    const cityOptions = profileData.state && statesCitiesMap[profileData.state]
        ? statesCitiesMap[profileData.state].map(city => ({
            value: city,
            label: city
        }))
        : [];

    useEffect(() => {
        fetchUserProfile();
    }, []);
    const handleStateChange = (selectedOption) => {
        setProfileData(prev => ({
            ...prev,
            state: selectedOption ? selectedOption.value : "",
            city: "" // Reset city when state changes
        }));

        const error = validateField("state", selectedOption ? selectedOption.value : "");
        setErrors(prev => ({
            ...prev,
            state: error,
            city: "" // Clear city error when state changes
        }));
    };

    // 7. Add handleCityChange function
    const handleCityChange = (selectedOption) => {
        setProfileData(prev => ({
            ...prev,
            city: selectedOption ? selectedOption.value : ""
        }));

        const error = validateField("city", selectedOption ? selectedOption.value : "");
        setErrors(prev => ({
            ...prev,
            city: error
        }));
    };

    const fetchUserProfile = async () => {
        try {
            const business_id = window.localStorage.getItem("business_id");
            const response = await fetchWithJWT(
                `/business/store/info?business_id=${business_id}`
            );
            const data = await response.json();

            if (data.status === "success") {
                // Map API response to profileData structure
                const result = data.result;
                setProfileData({
                    first_name: result.first_name || "", // Keep existing if available
                    last_name: result.last_name || "", // Keep existing if available
                    email_address: result.contact_info?.email || "",
                    business_name: result.business_name || "",
                    phone_number: result.contact_info?.phone || "",
                    address: result.contact_info?.address || "",
                    city: result.contact_info?.city || "",
                    state: result.contact_info?.state || "",
                    zipcode: result.contact_info?.zipcode || "",
                    country: result.contact_info?.country || "India"
                });
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
            toast.error("Failed to load profile data");
        } finally {
            setIsLoading(false);
        }
    };

    const validateField = (name, value) => {
        // Handle null/undefined values
        const safeValue = value || "";

        switch (name) {
            case "first_name":
            case "last_name":
                return safeValue.trim() === "" ? "This field is required" : "";
            case "business_name":
                return safeValue.trim() === "" ? "Business name is required" : "";
            case "email_address":
                if (!safeValue.trim()) return "Email is required";
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(safeValue)) return "Please enter a valid email address";
                return "";
            case "phone_number":
                if (!safeValue.trim()) return "Phone number is required";
                if (!/^\d{10}$/.test(safeValue)) return "Phone number must be 10 digits";
                return "";
            case "zipcode":
                if (!safeValue.trim()) return "ZIP code is required";
                if (!/^\d{6}$/.test(safeValue)) return "ZIP code must be 6 digits";
                return "";
            case "state":
                return safeValue.trim() === "" ? "Please select a state" : "";
            case "address":
                return safeValue.trim() === "" ? "Address is required" : "";
            case "city":
                return safeValue.trim() === "" ? "City is required" : "";
            default:
                return "";
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfileData(prev => ({
            ...prev,
            [name]: value
        }));

        // Validate field on change
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        const fieldsToValidate = [
            "first_name", "last_name", "business_name", "email_address", "phone_number",
            "address", "city", "state", "zipcode"
        ];

        fieldsToValidate.forEach(field => {
            const error = validateField(field, profileData[field]);
            if (error) {
                newErrors[field] = error;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            toast.error("Please fix all validation errors");
            return;
        }

        setIsSaving(true);
        try {
            const user_id = localStorage.getItem("user_id");
            const response = await api.post(
                '/business/profileupdate',
                {
                    user_id,
                    ...profileData
                }
            );

            if (response.data.status === "success") {
                toast.success("Profile updated successfully");
                setIsEditing(false);
            } else {
                toast.error(response.data.message || "Failed to update profile");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error(error.response?.data?.message || "Failed to update profile");
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return (
            <div className="wrapper" id="root">
                <LoadingSpinner message="Loading profile..." />
            </div>
        );
    }

    return (
        <div className="wrapper">
            <header>
                <NavigationBar />
            </header>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>{t('navigation.myProfile')}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h3 className="card-title">Profile Information</h3>
                                        <button
                                            className={`btn ml-auto ${isEditing ? 'btn-success' : 'btn-primary'}`}
                                            onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                                            disabled={isSaving}
                                        >
                                            {isSaving ? t('saving') : isEditing ? t('save_changes') : t('edit_profile')}
                                        </button>
                                    </div>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>{t("first_name")} *</label>
                                                    <input
                                                        type="text"
                                                        name="first_name"
                                                        className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                                                        value={profileData.first_name}
                                                        onChange={handleChange}
                                                        disabled={!isEditing}
                                                    />
                                                    {errors.first_name && (
                                                        <div className="invalid-feedback">{errors.first_name}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>{t("last_name")} *</label>
                                                    <input
                                                        type="text"
                                                        name="last_name"
                                                        className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                                                        value={profileData.last_name}
                                                        onChange={handleChange}
                                                        disabled={!isEditing}
                                                    />
                                                    {errors.last_name && (
                                                        <div className="invalid-feedback">{errors.last_name}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>{t("email")} *</label>
                                                    <input
                                                        type="email"
                                                        name="email_address"
                                                        className={`form-control ${errors.email_address ? 'is-invalid' : ''}`}
                                                        value={profileData.email_address}
                                                        onChange={handleChange}
                                                        disabled={!isEditing}
                                                    />
                                                    {errors.email_address && (
                                                        <div className="invalid-feedback">{errors.email_address}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>{t('phone_number')}</label>
                                                    <input
                                                        type="text"
                                                        name="phone_number"
                                                        className={`form-control ${errors.phone_number ? 'is-invalid' : ''}`}
                                                        value={profileData.phone_number}
                                                        onChange={handleChange}
                                                        disabled={true}
                                                        maxLength={10}
                                                    />
                                                    <small className="text-muted">{t('messages.phone_cannot_change')}</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t('business_name')} *</label>
                                            <input
                                                type="text"
                                                name="business_name"
                                                className={`form-control ${errors.business_name ? 'is-invalid' : ''}`}
                                                value={profileData.business_name}
                                                onChange={handleChange}
                                                disabled={!isEditing}
                                            />
                                            {errors.business_name && (
                                                <div className="invalid-feedback">{errors.business_name}</div>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>{t('address')} *</label>
                                            <textarea
                                                name="address"
                                                className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                                value={profileData.address}
                                                onChange={handleChange}
                                                disabled={!isEditing}
                                                rows={3}
                                            />
                                            {errors.address && (
                                                <div className="invalid-feedback">{errors.address}</div>
                                            )}
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('city')} *</label>
                                                    <Select
                                                        value={cityOptions.find(option => option.value === profileData.city)}
                                                        onChange={handleCityChange}
                                                        options={cityOptions}
                                                        placeholder="Select City"
                                                        isDisabled={!isEditing || !profileData.state}
                                                        className={errors.city ? 'is-invalid' : ''}
                                                        menuPlacement="top"
                                                    />
                                                    {errors.city && (
                                                        <div className="invalid-feedback d-block">{errors.city}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label> {t('state')} *</label>
                                                    <Select
                                                        value={stateOptions.find(option => option.value === profileData.state)}
                                                        onChange={handleStateChange}
                                                        options={stateOptions}
                                                        placeholder="Select State"
                                                        isDisabled={!isEditing}
                                                        className={errors.state ? 'is-invalid' : ''}
                                                        menuPlacement="top"
                                                    />
                                                    {errors.state && (
                                                        <div className="invalid-feedback d-block">{errors.state}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t('zip_code')} *</label>
                                                    <input
                                                        type="text"
                                                        name="zipcode"
                                                        className={`form-control ${errors.zipcode ? 'is-invalid' : ''}`}
                                                        value={profileData.zipcode}
                                                        onChange={handleChange}
                                                        disabled={!isEditing}
                                                        maxLength={6}
                                                    />
                                                    {errors.zipcode && (
                                                        <div className="invalid-feedback">{errors.zipcode}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {isEditing && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <button
                                                        className="btn btn-secondary mr-2"
                                                        onClick={() => {
                                                            setIsEditing(false);
                                                            fetchUserProfile(); // Reset data
                                                            setErrors({});
                                                        }}
                                                    >
                                                        {t('cancel')}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Profile;